import { lazyLoad } from "utils/loadable";

export const AdminManageUsers = lazyLoad(
  () => import("./index"),
  (module) => module.AdminManageUsers
);
